import _lib from '../_lib';
import active from './active/index';
import {MedicalReportsNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'medical_reports';
  let activations = [
    {
      name: 'medical_reports',
      test: api.messageIs(MedicalReportsNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};

